
(() => {
  const setup = (root) => {
    if (!root || root.dataset.accordionsReady === '1') return;
    root.dataset.accordionsReady = '1';

    if (root.dataset.allowMultiple === 'true') return;

    root.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        root.querySelectorAll('details[open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });
  };

  document.querySelectorAll('[data-info-accordions]').forEach(setup);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-info-accordions]').forEach(setup);
  });
})();
